{
  "name": "merchant-portal-frontend",
  "version": "1.0.9",
  "packageManager": "yarn@1.22.22",
  "scripts": {
    "ng": "ng",
    "start": "node ./utils/scripts/run-app.mjs",
    "build": "ng build",
    "build:int": "yarn generate:api:int && ng build --configuration int",
    "build:uat": "yarn generate:api:uat && ng build --configuration uat",
    "build:prd": "yarn generate:api:prd && ng build --configuration prd",
    "watch": "ng build --watch --configuration int",
    "test": "ng test",
    "test:coverage": "ng test --configuration=coverage",
    "test:ci": "ng test --configuration=ci --watch=false",
    "e2e": "playwright test",
    "e2e:ui": "playwright test --ui",
    "e2e:debug": "playwright test --debug",
    "e2e:ci": "E2E_ENV=int playwright test",
    "e2e:report": "playwright show-report playwright-report",
    "sonar": "node ./utils/scripts/run-sonar.mjs",
    "format": "prettier --write .",
    "format:check": "prettier --check .",
    "lint": "eslint \"src/**/*.{ts,js,html}\"",
    "lint:fix": "eslint \"src/**/*.{ts,js,html}\" --fix",
    "prepare": "husky",
    "commitlint": "commitlint",
    "lint-staged": "lint-staged",
    "generate:api": "node ./utils/scripts/generate-api.mjs",
    "generate:api:int": "node ./utils/scripts/generate-api.mjs int",
    "generate:api:uat": "node ./utils/scripts/generate-api.mjs uat",
    "generate:api:prd": "node ./utils/scripts/generate-api.mjs prd",
    "extract:translations": "node ./utils/scripts/scan-translation-keys.mjs",
    "docs": "compodoc -p tsconfig.compodoc.json -d documentation",
    "docs:serve": "compodoc -p tsconfig.compodoc.json -s -d documentation",
    "skills:install": "bash scripts/codex/install-skills.sh",
    "skills:validate": "bash scripts/codex/validate-skills.sh"
  },
  "private": true,
  "dependencies": {
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.25",
    "@angular/compiler": "^21.2.25",
    "@angular/core": "^21.2.25",
    "@angular/forms": "^21.2.25",
    "@angular/localize": "^21.2.25",
    "@angular/platform-browser": "^21.2.25",
    "@angular/router": "^21.2.25",
    "@bluehalo/ngx-leaflet": "^21.2.1",
    "@jsverse/transloco": "^8.4.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-icons/core": "^33.4.0",
    "@ng-icons/lucide": "^33.4.0",
    "@ng-icons/tabler-icons": "^33.4.0",
    "@popperjs/core": "^2.11.8",
    "angularx-flatpickr": "^8.1.0",
    "bootstrap": "^5.3.7",
    "chart.js": "^4.5.0",
    "choices.js": "^11.2.4",
    "esbuild": "^0.28.2",
    "flatpickr": "^4.6.13",
    "jsvectormap": "1.7.0",
    "leaflet": "^1.9.4",
    "lodash-es": "^4.18.1",
    "ng-otp-input": "^2.0.10",
    "ng2-charts": "^8.0.0",
    "ngx-countup": "^21.0.0",
    "ngx-dropzone-wrapper": "^17.0.0",
    "prettier": "^3.6.2",
    "rxjs": "~7.8.0",
    "simplebar-angular": "^3.3.1",
    "tslib": "^2.3.0"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^21.4.0",
    "@angular-eslint/eslint-plugin-template": "^21.4.0",
    "@angular-eslint/schematics": "^21.4.0",
    "@angular-eslint/template-parser": "^21.4.0",
    "@angular/build": "^21.2.28",
    "@angular/cli": "^21.2.28",
    "@angular/compiler-cli": "^21.2.25",
    "@angular/platform-browser-dynamic": "^21.2.25",
    "@commitlint/cli": "^20.5.3",
    "@commitlint/config-conventional": "^20.5.3",
    "@compodoc/compodoc": "^1.1.32",
    "@openapitools/openapi-generator-cli": "^2.42.0",
    "@playwright/test": "^1.63.0",
    "@types/jasmine": "~6.0.0",
    "@types/leaflet": "^1.9.19",
    "@types/lodash-es": "^4.17.12",
    "@typescript-eslint/eslint-plugin": "^8.69.0",
    "@typescript-eslint/parser": "^8.69.0",
    "eslint": "^9.39.4",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.12.0",
    "husky": "^9.1.7",
    "jasmine-core": "~6.0.1",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.2.0",
    "karma-junit-reporter": "^2.0.1",
    "lint-staged": "^16.4.0",
    "typescript": "~5.9.3",
    "zone.js": "^0.16.3"
  },
  "resolutions": {
    "@angular/core": "21.2.25",
    "@angular/compiler": "21.2.25",
    "**/basic-ftp": "6.2.1",
    "**/immutable": "5.1.9",
    "**/rollup": "4.63.1",
    "**/tar": "7.5.22",
    "**/flatted": "3.4.4",
    "**/handlebars": "4.7.10",
    "**/socket.io-parser": "4.2.7",
    "lint-staged/micromatch/picomatch": "2.3.2",
    "micromatch/picomatch": "2.3.2",
    "anymatch/picomatch": "2.3.2",
    "readdirp/picomatch": "2.3.2",
    "picomatch": "4.0.4",
    "@angular/build/vite": "7.3.7",
    "**/lodash": "4.18.1",
    "**/lodash-es": "4.18.1",
    "**/@nestjs/core": "11.1.18",
    "eslint/minimatch/brace-expansion": "1.1.21",
    "@eslint/config-array/minimatch/brace-expansion": "1.1.21",
    "@eslint/eslintrc/minimatch/brace-expansion": "1.1.21",
    "rimraf/glob/minimatch/brace-expansion": "1.1.21",
    "karma/**/brace-expansion": "1.1.21",
    "karma-coverage/minimatch/brace-expansion": "1.1.21",
    "**/glob/minimatch/brace-expansion": "5.0.12",
    "**/@ts-morph/common/minimatch/brace-expansion": "5.0.12",
    "**/path-to-regexp": "8.4.2",
    "**/undici": "7.30.1",
    "**/hono": "4.13.11",
    "**/@hono/node-server": "1.19.15",
    "**/file-type": "21.3.2",
    "**/qs": "6.16.1",
    "**/shell-quote": "1.11.0",
    "**/piscina": "5.3.2",
    "**/websocket-driver": "0.7.5",
    "**/engine.io": "6.6.10",
    "**/ws": "8.21.3",
    "**/fast-uri": "3.1.9",
    "**/tmp": "0.2.7",
    "**/adm-zip": "0.6.1",
    "**/browserslist": "4.28.9",
    "**/ip-address": "10.7.4",
    "**/js-yaml": "4.3.2",
    "**/sigstore": "4.1.1",
    "**/@babel/plugin-transform-modules-systemjs": "7.29.8",
    "@angular-eslint/schematics/@angular-devkit/core": "21.2.28",
    "@angular-eslint/schematics/@angular-devkit/schematics": "21.2.28",
    "**/@angular-devkit/core/ajv": "8.18.0",
    "**/ajv-formats/ajv": "8.18.0",
    "**/@commitlint/config-validator/ajv": "8.18.0",
    "@compodoc/compodoc/@angular-devkit/schematics": "21.2.28",
    "@compodoc/compodoc/@angular-devkit/core": "21.2.28",
    "**/@modelcontextprotocol/sdk": "1.32.1",
    "**/@modelcontextprotocol/sdk/ajv": "8.18.0",
    "@angular/cli/**/minimatch": "10.2.4",
    "@compodoc/compodoc/**/minimatch": "10.2.4",
    "karma/**/minimatch": "3.1.4",
    "karma-coverage/minimatch": "3.1.4",
    "@openapitools/openapi-generator-cli/axios": "1.20.0",
    "**/follow-redirects": "1.16.1",
    "**/postcss": "8.5.28",
    "**/uuid": "11.1.1",
    "**/@humanfs/node": "0.16.8",
    "**/morgan": "1.12.1",
    "karma/body-parser": "1.20.9",
    "@compodoc/compodoc/body-parser": "2.4.0",
    "**/express/body-parser": "2.4.0",
    "**/proxy-addr": "2.0.8",
    "**/source-map-js": "1.2.2",
    "**/zod": "4.6.6",
    "**/http-cache-semantics": "4.3.0",
    "**/@babel/core": "7.29.7",
    "**/esbuild": "0.28.2"
  },
  "lint-staged": {
    "*.{ts,js}": [
      "eslint --cache --fix",
      "prettier --write"
    ],
    "*.html": [
      "eslint --cache --fix",
      "prettier --write"
    ],
    "*.{scss,css,md,json}": [
      "prettier --write"
    ]
  }
}
